import React from "react";
import { getColors } from "../../../utils";
import { ImgV2 } from "../../ImgV2";
export const ReviewCard = ({ amountReviewStars, authorName, review, cardBackgroundColor }) => {
    const { bgColor } = getColors(cardBackgroundColor);
    return (React.createElement("div", { className: "review-card-root", style: { "--background-card-color": bgColor } },
        React.createElement("p", { className: "text-review" }, review),
        React.createElement("div", { className: "review-card-root__bottom-section" },
            React.createElement(ImgV2, { src: amountReviewStars, alt: amountReviewStars }),
            React.createElement("p", { className: "bottom-section__author-name" }, authorName))));
};
